import * as React from "react";
import useImage from "../hooks/useImage";

const Logo = ({ includeText = true, className = "", inverse = false, height, width = includeText ? 120 : 30, aspectRatio = includeText ? 1800 / 449 : 391 / 385 }) => {
  let logoFilename = "logo";
  if (includeText) {
    logoFilename += "-text";
  }
  if (inverse) {
    logoFilename += "-white";
  }
  logoFilename += ".svg";
  const logo = useImage(logoFilename, "Outplan Logo");
  return (
    <div className={className + " flex items-center"}>
      <div style={{ height, width, aspectRatio, overflow: "hidden", objectFit: "contain" }}>
        {logo}
      </div>
    </div>
  );
}

export default Logo;
